import axios from 'axios';

const BASE_URL = import.meta.env['VITE_API_BASE_URL'] as string | undefined ?? 'http://localhost:3000';

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT on every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

let isRefreshing = false;

// On 401, try refresh once then redirect to login
apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error.response?.status as number | undefined;
    if (status === 401 && !isRefreshing) {
      isRefreshing = true;
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        try {
          const { data } = await axios.post<{ accessToken: string }>(
            `${BASE_URL}/auth/refresh`,
            { refreshToken },
          );
          localStorage.setItem('accessToken', data.accessToken);
          isRefreshing = false;
          error.config.headers['Authorization'] = `Bearer ${data.accessToken}`;
          return apiClient.request(error.config);
        } catch {
          // refresh failed — fall through to redirect
        }
      }
      isRefreshing = false;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);
